import React from 'react'
import CharterImg from "../assets/images/Yacht.png";
export const BookingImages = () => {
  return (
    <div className="bookingImg">
       <img src={CharterImg} alt="Charter" />
    </div>
  )
}
